export default __webpack_public_path__ + "static/media/basic-pin-large-1.de25c04d.png";